import { useEffect } from 'react';
import { useDmControlRoute } from './control/useDmControlRoute';
import type { ActionRunnerProps } from '../types';

// The Actions tab's entry: it opens the URL-driven DM control modal and hands straight back.
// PatientFiles renders the modal (DmControlRoute), so it stays open across tab switches.
function ManageMonitoringLanding({ patientId, onBack }: ActionRunnerProps) {
    const { open } = useDmControlRoute(patientId);
    useEffect(() => {
        open();
        onBack();
        // Once per selection: the card mounts this runner each time it is picked.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
}

export { ManageMonitoringLanding };
